<div class="footerArea" [class]="(isHome)?'extended':''">
    <div class="wrapperMain" *ngIf="isHome">
        <div class="footer-info mt-20">
            <div class="column">
                <h3>Contact Us</h3>
                <ul>
                    <li class="doublespace"><a href="mailto:info@kilowant.com">info&#64;kilowant.com</a></li>
                    <li class="doublespace">401.487.1652</li>
                    <li class="doublespace">
                        Kilowant LLC
                        <br />
                        P.O. Box 299
                        <br />
                        Charlestown, RI 02813
                    </li>
                </ul>
            </div>
            <div class="column">
                <h3>Kilowant Links</h3>
                <ul>
                    <li><a (click)="goto('/user/kilowant-u')">kilowant U</a></li>
                    <li><a (click)="goto('/our-story')">Our Story</a></li>
                    <li><a (click)="goto('/faq')">FAQ</a></li>
                    <li><a (click)="goto('/user/registration')">Sign Up</a></li>
                    <li><a (click)="goto('/user/login')">Sign In</a></li>
                    <li><a (click)="goto('/tou')">Terms of Use</a></li>
                    <li><a (click)="goto('/privacy-policy')">Privacy Policy</a></li>
                </ul>
            </div>
        </div>
        <div class="footer-info f13">
            <h3>About Kilowant</h3>
            kilowant lowers your electric bill by using AI to autonomously shop for low-priced electricity supply plans...saving you time and money. Our innovative AI-enabled "Nonstop Shop (TM)" technology searches for market opportunities 24/7 and sources discounted electricity price plans as an alternative to your utility and community energy supply rates. Participating third-party suppliers are state registered, PUC licensed, and utility approved. All price plan offers are fixed-rate and fixed-term, yielding guaranteed savings with no unauthorized renewals. kilowant is your trusted partner for a smarter, sustainable, more affordable energy solution, ensuring you save money without the hassle of extensive research or risk of poor market timing.
            <div class="text-center mt-10">
                <a class="facebook-link" href="https://www.facebook.com/kilowant/"></a>
                <a class="instagram-link" href="https://www.instagram.com/kilowant/"></a>
                <a class="linkedin-link" href="https://www.linkedin.com/company/kilowant/"></a>
            </div>
        </div>
    </div>
    <div class="footerIcon mt-10"></div>
    <div class="footer" (click)="gotoLogin()">Copyright &copy; 2022 - {{currentYear()}} kilowant, LLC</div>
</div>
